import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-ink text-white" data-id="element-411" data-mp="2bwe6imbbrd3g">
      <div className="max-w-3xl mx-auto px-5 py-14 sm:py-16 text-center" data-id="element-412" data-mp="2bw5t8tbai5rq">
        <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-amber" data-id="element-413" data-mp="1x06q7x31evtg">Limited-time offer</p>
        <h2 className="mt-3 font-display text-2xl font-extrabold text-white sm:text-4xl" data-id="element-414" data-mp="21xghzjdwfjkg">The launch price ends in:</h2>
        <div className="mt-6" data-id="element-415" data-mp="1o5ig9tmiopyb">
          <Countdown tone="dark" data-id="element-416" data-mp="1sxthr0wwojsz" />
        </div>
        <p className="mt-5 text-sm text-white/70" data-id="element-417" data-mp="1sylfoidz6tmf">
          After that the price goes up by <span className="font-bold text-coral" data-id="element-418" data-mp="1e9oztz5ogcb9">$47</span> and stays there.
        </p>
      </div>
    </section>;
}